<template>
<v-app color="primary">
    <navbar v-if="oidcUser">
        <template v-slot:left>
            <v-btn :ripple="false" color="primary" depressed @click="closeSidebar">
                <!-- Cerrar &nbsp; -->
                <v-icon>mdi-apps</v-icon>
            </v-btn>
            <!-- <v-app-bar-nav-icon @click="closeSidebar" /> -->
            <v-container id="miicon">
                <v-img width="145" :src="require('@/assets/ug_escudo.png')" alt="logo" />
            </v-container>

            <v-toolbar-title class="headline text-uppercase hidden-sm-and-down">
                <!-- <span class="black--text">UG/</span> -->
                <span class="font-weight-light white--text">OBLIGACIONES</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </template>
        <template v-slot:right>
            <UserItem
            v-if="$route.meta.isPublic === true || (empleadoDatos && empleadoDatos.Id_Empleado)" 
                    :email="oidcUser.email"
                    :nue="empleadoDatos.Id_Empleado"
                />
        </template>
        <template class="hidden-sm-and-down" v-slot:menu-items>
            <Notificacion v-if="oidcAccessToken" :token="oidcAccessToken" />
        </template>
    </navbar>
   <!-- <left-sidebar v-if="$route.meta.isPublic === true || (empleadoDatos && empleadoDatos.Id_Empleado && empleadoDatos.Email)" :nue="empleadoDatos.Id_Empleado" :left="left" :close-sidebar="closeSidebar" :nombre="empleadoDatos.Email" :email="empleadoDatos.Email" />-->

    <left-sidebar v-if="$route.meta.isPublic === true || (empleadoDatos && empleadoDatos.Id_Empleado && empleadoDatos.Email)"  :left="left" :close-sidebar="closeSidebar" />

    <v-content>
        <v-sheet align="right" height="100%" style="position: relative; background-color: transparent!important" class="overflow-hidden">
            <v-btn style="margin-top:-5px" small elevation="5" color="#f5f5f5" v-if="!drawer && oidcUser" absolute top left @click="drawer = !drawer; menuIzMin=false">
                <v-icon>mdi-menu</v-icon>
            </v-btn>

            <v-content class="pt-5" :style="estilos">
                <router-view align="left" v-if="$route.meta.isPublic === true || (empleadoDatos && empleadoDatos.Id_Empleado && empleadoDatos.Email)"  />
            </v-content>

            <div v-if="oidcUser" @mouseleave="menuIzMin=true">
                <v-navigation-drawer id="menuIzq" width="250px" style="background-color:#f5f5f5" v-model="drawer" absolute :expand-on-hover="menuIzMin" @click="drawer = !drawer">
                    <div class="pa-2">
                        <v-btn elevation="0" block small @click="drawer = !drawer">
                            <v-icon color="primary">mdi-menu</v-icon>
                        </v-btn>
                    </div>

                    <v-divider></v-divider>

                    <!-- <v-list dense nav left align="left">
                            <v-list-item  v-for="item in items" :key="item.title" :to="item.link" >
          <v-list-item-icon>
            <v-icon color="primary" >{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title >{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

            </v-list>-->

                    <Lbar v-if="$route.meta.isPublic === true || (empleadoDatos && empleadoDatos.Id_Empleado)"  :nue="empleadoDatos.Id_Empleado" :left="left" :close-sidebar="closeSidebar" :nombre="oidcUser.email" :email="oidcUser.email" />
                </v-navigation-drawer>
            </div>
        </v-sheet>

        <!-- <comentarios :comentarios="comentarios" /> -->
    </v-content>

    <!-- </v-flex>   -->
    <Footer v-if="oidcUser" class="hidden-sm-and-down" />
</v-app>
</template>

<script>
// import DtUnidad from '.components/DtUnidad.vue'
// import { Calendar } from 'dayspan';
import {
    mapState,
    mapGetters,
    mapActions
} from "vuex";
// import {StatsCard} from 'src/components'
import {
    StatsCard
} from "./plugins/components";
import {
    UserItem,
    Notificacion,
    Navbar,
    Footer,
    LeftSidebar,
    Comentarios,
    Lbar
} from "./components/layout";

// import {ChartCard} from 'src/components'
export default {
    components: {
        UserItem,
        LeftSidebar,
        Notificacion,
        Navbar,
        Comentarios,
        Footer,
        Lbar
    },

    computed: {
        ...mapGetters({
            oidcUser: "oidcStore/oidcUser",
            oidcAccessToken: "oidcStore/oidcAccessToken"
        }),
        ...mapState(['msize','empleadoDatos']),
        estilos() {
            if (this.$vuetify.breakpoint.mdAndDown)
                return 'padding-bottom:1%; '
            else
                return 'padding-bottom:1%; margin-left: 120px; margin-right:38px;'
        }
    },
    async mounted() {
    //window.addEventListener('vuexoidc:userLoaded', await this.obtenerEmpleado)
    await window.addEventListener('vuexoidc:userLoaded', async (e) => {
      this.obtenerEmpleado(e)
    })
    
  },
    methods: {
        ...mapActions({
            signOutOidc: "oidc/signOutOidc",
            getCategorias: "getCategorias",
            obtenerEmpleado: "obtenerEmpleado"
        }),

        closeSidebar() {
            this.left = !this.left;
        }
    },

    name: "App",

    data: () => ({
        menuIzMin: true,
        drawerRight: true,
        collapseOnScroll: false,
        ventana: 1,
        comentarios: false,
        left: false,
        right: false,
        list: null,
        drawer: null,
        oidcIsAuthenticated: "",
        dialog: false,
        cdesserts: [],

        items: [{
                title: "Unidad",
                icon: "ballot",
                link: "/DtUnidad"
            },
            {
                title: "Inicio",
                icon: "desktop_mac",
                link: "/"
            },
            {
                title: "Periodo",
                icon: "event_note",
                link: "/CatPeriodo"
            },
            {
                title: "Usuarios",
                icon: "person_add",
                link: "/CatUsuarios"
            },
            {
                title: "Fracciones",
                icon: "sort",
                link: "/CatFraccion"
            }
            //  { title: 'Archivo',  icon: 'list',           link: '/CatArchivo' },
        ]
    })
};
</script>

<style>
#eltool {
    border-radius: 0px 0px 0px 15px;
    -moz-border-radius: 0px 0px 0px 15px;
    -webkit-border-radius: 0px 0px 0px 15px;
    border: 0px solid #000000;
}

.v-toolbar__content {
    padding-left: 9px !important;
    padding-right: 9px !important;
}

#miicon {
    padding-left: 9px !important;
    padding-right: 9px !important;
}

.theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {
    background-color: transparent !important;
}

#menuIzq {
    -webkit-box-shadow: 0px 0px 12px 2px rgba(0, 0, 0, 0.13);
    -moz-box-shadow: 0px 0px 12px 2px rgba(0, 0, 0, 0.13);
    box-shadow: 0px 0px 12px 2px rgba(0, 0, 0, 0.13);
}
</style>
